<template>
<div>
    <kt-col v-if="user.national_card_file" class="text-center">
        <kt-img-magnifier class="mb-4" :src="user.authentication_file"></kt-img-magnifier>
        <kt-img-magnifier class="mb-4" :src="user.national_card_file"></kt-img-magnifier>
    </kt-col>
    <kt-col v-else class="text-center">
        <p class="bg-warning text-dark p-3">
            {{ $t('not_uploaded_yet') }}
        </p>
    </kt-col>

    <kt-col>
        <form v-if="status === 'success'" id="update_form" class="mt-5" @submit.prevent="changeUserSetting">
            <kt-form-group>
                <kt-form-label>
                    {{ $t('label.change_status') }}
                </kt-form-label>
                <kt-form-select
                        class="form-control kt-selectpicker"
                        size="3"
                        id="status"
                        name="status"
                        v-model="user.status"
                        @change="checkIfRejectedStatusSelect(user.status)"
                >
                <option
                        v-bind:key="index"
                        v-for="(status, index) in statuses"
                        v-bind:value="status.value"
                        :selected="user.status === status.value"
                    >
                        {{ status.name }}
                    </option>
                </kt-form-select>
            </kt-form-group>

            <kt-form-group v-if="user.status === userStatus.AUTHORIZATION_DOCUMENTS_REJECTED || is_rejected_user_status">
                <kt-form-label for="rejected_status_description">
                    {{ $t('label.auth_documentation_rejection_reason') }}
                </kt-form-label>
                <textarea
                        class="form-control no-resize"
                        rows="6"
                        id="rejected_status_description"
                        name="rejected_status_description"
                        v-model="user.rejected_status_description"
                ></textarea>
            </kt-form-group>


            <kt-form-group>
                <kt-form-label>
                    {{ $t('label.referer') }}
                </kt-form-label>
                <select
                        class="form-control kt-selectpicker"
                        id="referer"
                        v-model="user.referer_id"
                        name="referer"
                >
                    <option>{{ $t('selectpicker.nothing') }}</option>
                    <option
                            v-bind:key="index"
                            v-for="(referer, index) in referersList"
                            v-bind:value="referer.id"
                    >
                        {{ referer.full_name }} {{' - '}} {{referer.phone}}
                    </option>
                </select>
            </kt-form-group>
            <kt-form-group v-if="user.referer_id">
                <kt-form-label>
                    {{ $t('label.profit_percent') }}
                </kt-form-label>
                <kt-form-control
                        class="form-control"
                        type="number"
                        id="profit_percent"
                        v-model="user.referer_percent"
                        name="profit_percent"
                        placeholder="0-100"
                        maxlength="3"
                        min="0"
                        max="100"
                >
                </kt-form-control>
            </kt-form-group>

            <kt-row>
                <kt-col xs="12" md="6">
                    <kt-form-action class="mt-4">
                        <button class="btn btn-md btn-success btn-wide" type="submit" id="change_status_btn">
                            {{ $t('btn.edit') }}
                        </button>
                    </kt-form-action>
                </kt-col>
                <kt-col xs="12" md="6">
                    <kt-form-action class="mt-4">
                        <button
                                class="btn btn-md btn-primary btn-wide"
                                type="button"
                                data-toggle="modal"
                                data-target="#user-access-modal"
                                id="change_user_access_btn"
                        >
                            {{ $t('btn.change_user_access') }}
                        </button>
                    </kt-form-action>

                    <!-- Modal -->
                    <div id="user-access-modal" class="modal fade" role="dialog">
                        <div class="modal-dialog">
                            <!-- Modal content-->
                            <div class="modal-content" id="user-access-modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">
                                        {{ $t('label.change_user_access') }}
                                    </h4>
                                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                                </div>
                                <div class="modal-body">

                                    <p>{{ $t('label.choose_user_access') }}</p>
                                    <kt-form-section>
                                        <kt-row class="mb-3">
                                            <kt-col lg="12" md="12" xs="12">
                                                <div class="custom-control custom-checkbox" id="gateway-div">
                                                    <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="manage-gateway"
                                                            name="manage_gateway"
                                                            v-model="user.access.gateway"
                                                    >
                                                    <label class="custom-control-label" for="manage-gateway">
                                                        {{ $t('label.manage_gateway') }}
                                                    </label>
                                                </div>
                                            </kt-col>
                                        </kt-row>
                                        <kt-row class="mb-3">
                                            <kt-col lg="12" md="12" xs="12">
                                                <div class="custom-control custom-checkbox" id="user-div">
                                                    <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="manage-user"
                                                            name="manage_user"
                                                            v-model="user.access.user"
                                                    >
                                                    <label class="custom-control-label" for="manage-user">
                                                        {{ $t('label.manage_user') }}
                                                    </label>
                                                </div>
                                            </kt-col>
                                        </kt-row>
                                        <kt-row class="mb-3">
                                            <kt-col lg="12" md="12" xs="12">
                                                <div class="custom-control custom-checkbox" id="ticket-div">
                                                    <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="manage-ticket"
                                                            name="manage_ticket"
                                                            v-model="user.access.ticket"
                                                    >
                                                    <label class="custom-control-label" for="manage-ticket">
                                                        {{ $t('label.manage_ticket') }}
                                                    </label>
                                                </div>
                                            </kt-col>
                                        </kt-row>
                                        <kt-row class="mb-3">
                                            <kt-col lg="12" md="12" xs="12">
                                                <div class="custom-control custom-checkbox" id="transaction-div">
                                                    <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="manage-transaction"
                                                            name="manage_transaction"
                                                            v-model="user.access.transaction"
                                                    >
                                                    <label class="custom-control-label" for="manage-transaction">
                                                        {{ $t('label.manage_transaction') }}
                                                    </label>
                                                </div>
                                            </kt-col>
                                        </kt-row>
                                        <kt-row class="mb-3">
                                            <kt-col lg="12" md="12" xs="12">
                                                <div class="custom-control custom-checkbox" id="store-div">
                                                    <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="manage-store"
                                                            name="manage_store"
                                                            v-model="user.access.store"
                                                    >
                                                    <label class="custom-control-label" for="manage-store">
                                                        {{ $t('label.manage_store') }}
                                                    </label>
                                                </div>
                                            </kt-col>
                                        </kt-row>
                                        <kt-row class="mb-3">
                                            <kt-col lg="12" md="12" xs="12">
                                                <div class="custom-control custom-checkbox" id="product-div">
                                                    <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="manage-product"
                                                            name="manage_product"
                                                            v-model="user.access.product"
                                                    >
                                                    <label class="custom-control-label" for="manage-product">
                                                        {{ $t('label.manage_product') }}
                                                    </label>
                                                </div>
                                            </kt-col>
                                        </kt-row>
                                        <kt-row class="mb-3">
                                            <kt-col lg="12" md="12" xs="12">
                                                <div class="custom-control custom-checkbox" id="pardakht-shakhsi-div">
                                                    <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="manage-pardakht-shakhsi"
                                                            name="manage_pardakht_shakhsi"
                                                            v-model="user.access.pardakht_shakhsi"
                                                    >
                                                    <label class="custom-control-label" for="manage-pardakht-shakhsi">
                                                        {{ $t('label.manage_pardakht_shakhsi') }}
                                                    </label>
                                                </div>
                                            </kt-col>
                                        </kt-row>
                                        <kt-row class="mb-3">
                                            <kt-col lg="12" md="12" xs="12">
                                                <div class="custom-control custom-checkbox" id="news-div">
                                                    <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="manage-news"
                                                            name="manage_pardakht_shakhsi"
                                                            v-model="user.access.news"
                                                    >
                                                    <label class="custom-control-label" for="manage-news">
                                                        {{ $t('label.manage_news') }}
                                                    </label>
                                                </div>
                                            </kt-col>
                                        </kt-row>
                                    </kt-form-section>
                                    <kt-form-action class="mt-4">
                                        <kt-button
                                                class="m-2 btn-wide"
                                                size="md"
                                                variant="success"
                                                type="button"
                                                v-bind:wide="true"
                                                id="submit_access_change_btn"
                                                @click="changeAccess"
                                        >
                                            {{ $t('btn.edit') }}
                                        </kt-button>
                                    </kt-form-action>

                                    <hr>
                                    <p>{{ $t('label.choose_user_notif') }}</p>
                                  <form v-if="status === 'success'" id="update_notification_form" @submit.prevent="changeUserNotificationSetting">
                                    <kt-form-section>
                                        <kt-row class="mb-3">
                                            <kt-col lg="12" md="12" xs="12">
                                                <div class="custom-control custom-checkbox" id="gateway-div">
                                                    <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="new_user_notif"
                                                            name="send_new_auth"
                                                            v-model="user.notification.send_new_auth"
                                                    >
                                                    <label class="custom-control-label" for="new_user_notif">
                                                        {{ $t('label.new_user_notif') }}
                                                    </label>
                                                </div>
                                            </kt-col>
                                        </kt-row>
                                        <kt-row class="mb-3">
                                            <kt-col lg="12" md="12" xs="12">
                                                <div class="custom-control custom-checkbox" id="user-div">
                                                    <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="new_gateway_notif"
                                                            name="send_new_terminal"
                                                            v-model="user.notification.send_new_terminal"
                                                    >
                                                    <label class="custom-control-label" for="new_gateway_notif">
                                                        {{ $t('label.new_gateway_notif') }}
                                                    </label>
                                                </div>
                                            </kt-col>
                                        </kt-row>
                                        <kt-row class="mb-3">
                                            <kt-col lg="12" md="12" xs="12">
                                                <div class="custom-control custom-checkbox" id="user-div">
                                                    <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="new_ticket_notif"
                                                            name="send_new_ticket"
                                                            v-model="user.notification.send_new_ticket"
                                                    >
                                                    <label class="custom-control-label" for="new_ticket_notif">
                                                        {{ $t('label.new_ticket_notif') }}
                                                    </label>
                                                </div>
                                            </kt-col>
                                        </kt-row>
                                    </kt-form-section>
                                    <kt-form-action class="mt-4">
                                        <kt-button
                                                class="m-2 btn-wide"
                                                size="md"
                                                variant="success"
                                                type="button"
                                                v-bind:wide="true"
                                                id="submit_notification_change_btn"
                                                @click="changeUserNotificationSetting"
                                        >
                                            {{ $t('btn.notif_edit') }}
                                        </kt-button>
                                    </kt-form-action>
                                  </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </kt-col>
            </kt-row>
        </form>
    </kt-col>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { userStatusStr, userStatus } from '@/constants/userStatus'
import { userService } from '@/common/api.service'
import { KTApp } from '@/plugins/core/app'
import $ from 'jquery'
import toastr from 'toastr'
import { i18n } from '@/plugins/i18n'

export default {
    data() {
        return {
            statuses: [
                {
                    name: userStatusStr.ACTIVE,
                    value: userStatus.ACTIVE
                },
                {
                    name: userStatusStr.AUTHORIZATION_DOCUMENTS_REJECTED,
                    value: userStatus.AUTHORIZATION_DOCUMENTS_REJECTED
                },
                {
                    name: userStatusStr.REMOVED,
                    value: userStatus.REMOVED
                },
                {
                    name: userStatusStr.IS_AUTHENTICATED,
                    value: userStatus.IS_AUTHENTICATED
                },
                {
                    name: userStatusStr.IS_AUTHENTICATED_PENDING,
                    value: userStatus.IS_AUTHENTICATED_PENDING
                },
                {
                    name: userStatusStr.ENAMAD_AUTHENTICATED,
                    value: userStatus.ENAMAD_AUTHENTICATED
                },
            ],
            userStatus: userStatus,
            is_rejected_user_status: false
        }
    },
    computed: {
        ...mapGetters('user', [
            'user', 'status', 'referersList'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    mounted() {
        this.$store.dispatch('user/fetchReferers').finally(() => {
            this.afterDispatch()
        })
    },
    methods: {
        checkIfRejectedStatusSelect(status) {
            this.is_rejected_user_status = status == userStatus.AUTHORIZATION_DOCUMENTS_REJECTED;
        },
        changeUserSetting(e) {
            let btn = $('#change_status_btn')
            let form = $('#update_form')

            KTApp.progress(btn)

            if (this.user.status != userStatus.AUTHORIZATION_DOCUMENTS_REJECTED)
                this.user.rejected_status_description = ''

            let params = {
                status: this.user.status,
                referer_id: this.user.referer_id,
                referer_percent: this.user.referer_percent,
                rejected_status_description: this.user.rejected_status_description,
            }

            userService.changeUserSetting(this.user.id, params)
                .then(response => {
                    this.showMsg(form, 'success', response.data.message)
                    this.$store.dispatch('badgeCounter/countData')
                })
                .catch(({response}) => {
                this.showMsg(form, 'danger', response.data.message)
                })
                .finally(
                response => {
                    KTApp.unprogress(btn)
                }
            )
        },
        changeAccess(e) {
            let form = $('#user-access-modal-content')
            let btn = $('#submit_access_change_btn')

            KTApp.progress(btn)

            userService.changeAccess(this.user.id, {
                gateway: this.user.access.gateway,
                user: this.user.access.user,
                ticket: this.user.access.ticket,
                transaction: this.user.access.transaction,
                store: this.user.access.store,
                product: this.user.access.product,
                pardakht_shakhsi: this.user.access.pardakht_shakhsi,
                news: this.user.access.news,
            }).then(response => {
                this.toastr.success(response.data.message)
            }).catch(({response}) => {
                this.toastr.fail(response.data.message)
            }).finally(() => {
                    KTApp.unprogress(btn)
                }
            )
        },
        changeUserNotificationSetting(e) {
            let btn = $('#submit_notification_change_btn')
            let form = $('#update_notification_form')

            KTApp.progress(btn)

            userService.changeNotificationAccess(this.user.id, {
                send_new_auth: this.user.notification.send_new_auth,
                send_new_terminal: this.user.notification.send_new_terminal,
                send_new_ticket: this.user.notification.send_new_ticket
            }).then(response => {
                this.toastr.success(response.data.message)
            }).catch(({response}) => {
                this.toastr.fail(response.data.message)
            }).finally(() => {
                    KTApp.unprogress(btn)
                }
            )
        },
        afterDispatch() {
            setTimeout(function () {
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                })
            }, 2000)
        },
    }
}
</script>

<style>
    .modal .modal-content .modal-header .close:before {
        content: ""!important;
    }
    .modal .modal-content .modal-header .close {
        font-size: 1.8rem;
        line-height: .7;
    }
    .dropdown.bootstrap-select.form-control.kt-.dropup .dropdown-menu .inner ul.dropdown-menu.inner {
        min-width: initial!important;
    }
</style>
